// extracted by mini-css-extract-plugin
module.exports = {"suggestions-wrapper":"_19aFTk-FxRsubo96E8CZJ6","suggestions-container":"eckmEamQnwKI_CxuZVN80"};